var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"home-container-footer"},[_c('span',[_vm._v(" Jesteś dealerem? "),_c('a',{attrs:{"href":"https://infopanel.cloud/","target":"_blank"}},[_vm._v("Dowiedz się więcej!")])])])
}]

export { render, staticRenderFns }